import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const BlogPage = () => {
  const siteUrl = 'https://www.marketingcalculatorhub.com';
  const pageUrl = `${siteUrl}/blog`;
  const logoUrl = `${siteUrl}/logo.png`;

  return (
    <div className="container mx-auto px-4 py-8">
      <Helmet>
        <title>Marketing Insights Blog: Expert Tips & Strategies | Marketing Calculator Hub</title>
        <meta name="description" content="Explore our marketing insights blog for expert tips, strategies, and in-depth analyses. Stay updated with the latest trends in digital marketing, SEO, and more." />
        <meta name="keywords" content="marketing blog, digital marketing insights, marketing strategies, SEO tips, content marketing, email marketing" />
        <link rel="canonical" href={pageUrl} />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:title" content="Marketing Insights Blog: Expert Tips & Strategies | Marketing Calculator Hub" />
        <meta property="og:description" content="Explore our marketing insights blog for expert tips, strategies, and in-depth analyses. Stay updated with the latest trends in digital marketing, SEO, and more." />
        <meta property="og:image" content={logoUrl} />

        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content={pageUrl} />
        <meta property="twitter:title" content="Marketing Insights Blog: Expert Tips & Strategies | Marketing Calculator Hub" />
        <meta property="twitter:description" content="Explore our marketing insights blog for expert tips, strategies, and in-depth analyses. Stay updated with the latest trends in digital marketing, SEO, and more." />
        <meta property="twitter:image" content={logoUrl} />

        {/* Schema.org JSON-LD */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Blog",
            "name": "Marketing Insights Blog",
            "description": "Expert marketing tips, strategies, and in-depth analyses on digital marketing, SEO, and more.",
            "url": pageUrl,
            "publisher": {
              "@type": "Organization",
              "name": "Marketing Calculator Hub",
              "logo": {
                "@type": "ImageObject",
                "url": logoUrl
              }
            }
          })}
        </script>
      </Helmet>
      <h1 className="text-3xl font-bold text-gray-800 mb-6">Marketing Insights Blog</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <BlogPostCard
          title="Mastering Email Marketing: Strategies for Success"
          description="Learn how to create effective email campaigns that drive engagement and conversions."
          link="/blog/mastering-email-marketing"
        />
        {/* Add more blog post cards here */}
      </div>
    </div>
  );
};

const BlogPostCard = ({ title, description, link }) => (
  <div className="bg-white rounded-lg shadow-md p-6">
    <h2 className="text-xl font-semibold text-gray-800 mb-2">{title}</h2>
    <p className="text-gray-600 mb-4">{description}</p>
    <Link to={link} className="text-indigo-600 hover:text-indigo-800 font-medium">
      Read More
    </Link>
  </div>
);

export default BlogPage;
